// extracted by mini-css-extract-plugin
export default {"description":"description__7pkrr","__open":"__open__7pkrr","__close":"__close__7pkrr","description__bottomSheet-text":"description__bottomSheet-text__7pkrr"};